(() => {
  const modal = document.querySelector('[data-gp-enquiry-modal]');
  if (!modal) return;
  const panel = modal.querySelector('.gp-enquiry-modal__panel');
  let returnFocus = null;

  const text = (value) => String(value || '').trim();
  const closestText = (trigger, selectors) => {
    const scope = trigger.closest('[data-gp-product-card], .gp-product, [data-gpse-collector], article, section') || document;
    for (const selector of selectors) {
      const node = scope.querySelector(selector);
      if (node && text(node.textContent)) return text(node.textContent);
    }
    return '';
  };

  function detailsFor(trigger) {
    const title = text(trigger.dataset.enquiryTitle) || closestText(trigger, ['[data-gpse-collector-title]', '.gp-product__info h1', '.gp-card__title', 'h1', 'h2', 'h3']) || document.title;
    const variant = trigger.closest('.gp-product, [data-gpse-collector], [data-gp-product-card]')?.querySelector('select option:checked');
    const price = text(trigger.dataset.enquiryPrice) || closestText(trigger, ['[data-gpse-collector-price]', '[data-product-price]', '[data-gp-card-price]', '.gpsec__price', '.gp-price']);
    const isCollection = /complete collection|collection consultation|enquire about the collection/i.test(title + ' ' + text(trigger.textContent));
    let customSize = '';
    if (trigger.matches('[data-custom-size-request]')) {
      const scope = trigger.closest('.gp-product') || document;
      const width = text(scope.querySelector('[data-custom-width]')?.value);
      const height = text(scope.querySelector('[data-custom-height]')?.value);
      const unit = text(scope.querySelector('[data-custom-unit]')?.value);
      const note = text(scope.querySelector('[data-custom-note]')?.value);
      customSize = [width && height ? `Requested size: ${width} × ${height} ${unit}` : '', note].filter(Boolean).join(' · ');
    }
    const detail = isCollection ? 'Price on enquiry' : [customSize, variant && text(variant.textContent), price].filter(Boolean).join(' · ');
    return { title, detail, isCollection, url: window.location.href };
  }

  function open(trigger) {
    returnFocus = trigger || document.activeElement;
    const info = detailsFor(trigger || document.body);
    const summary = modal.querySelector('[data-gp-enquiry-summary]');
    const label = modal.querySelector('[data-gp-enquiry-summary-label]');
    const title = modal.querySelector('[data-gp-enquiry-summary-title]');
    const detail = modal.querySelector('[data-gp-enquiry-summary-detail]');
    const titleInput = modal.querySelector('[data-gp-enquiry-artwork]');
    const detailInput = modal.querySelector('[data-gp-enquiry-details]');
    const urlInput = modal.querySelector('[data-gp-enquiry-url]');
    if (label) label.textContent = info.isCollection ? 'Collection of interest' : 'Artwork of interest';
    if (title) title.textContent = info.title;
    if (detail) { detail.textContent = info.detail; detail.hidden = !info.detail; }
    modal.querySelectorAll('[data-gp-enquiry-collection-only]').forEach((item) => { item.hidden = !info.isCollection; });
    if (summary) summary.hidden = !info.title;
    if (titleInput) titleInput.value = info.title;
    if (detailInput) detailInput.value = info.detail;
    if (urlInput) urlInput.value = info.url;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gp-enquiry-lock');
    window.setTimeout(() => panel?.focus(), 30);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gp-enquiry-lock');
    returnFocus?.focus?.();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gp-enquiry-open]');
    if (trigger) { event.preventDefault(); event.stopPropagation(); open(trigger); return; }
    if (event.target.closest('[data-gp-enquiry-close]')) { event.preventDefault(); close(); return; }
    const link = event.target.closest('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && (/^\/cart\/?$/.test(url.pathname) || /^\/checkout\/?$/.test(url.pathname))) {
        event.preventDefault(); open(link);
      }
    } catch (error) {}
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id === 'GpPrivateAcquisitionForm') return;
    if ((form.action || '').includes('/cart')) {
      event.preventDefault(); event.stopImmediatePropagation();
      open(event.submitter || form.querySelector('[type="submit"]') || form);
    }
  }, true);

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  if (modal.querySelector('[data-gp-enquiry-success]')) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); }
  if (new URL(window.location.href).searchParams.get('private_enquiry') === '1') open(document.body);
})();
